module.exports = __webpack_public_path__ + "img/item6-1.b9671091.png";